import { Container } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import CONFIG_KEYS from "../config";
import SiteLogo from "../component/SiteLogo";
import React, { useEffect, useState } from "react";
import { CategoryModel } from "../generated/api";
import { CommonService } from "../service/CommonService";
import { pageRouteUrls } from "../helper/pageRouteUrls";

export const Footer = () => {
    const { t } = useTranslation();
    const [categories, setCategories] = useState<CategoryModel[]>([]);

    useEffect(() => {
        new CommonService().getAllCategories()
            .then(cats => setCategories(cats/*.slice(0, 6)*/))
            .catch(() => {});
    }, []);
    const DownloadApp = () => {
        return (
            <div className="section section-padding download-section">

                <div className="app-shape-1"></div>
                <div className="app-shape-2"></div>
                <div className="app-shape-3"></div>
                <div className="app-shape-4"></div>

                <div className="container">

                    {/* Download App Wrapper Start */}
                    <div className="download-app-wrapper mt-n6">

                        {/* Section Title Start */}
                        <div className="section-title section-title-white">
                            <h5 className="sub-title">Ready to start?</h5>
                            <h2 className="main-title">Download our mobile app. for easy to start your course.</h2>
                        </div>
                        {/* Section Title End */}

                        <img className="shape-1 animation-right" src="/assets/images/shape/shape-14.png" alt="Shape" />

                        {/* Download App Button End */}
                        <div className="download-app-btn">
                            <ul className="app-btn">
                                <li><a href="#"><img src="/assets/images/google-play.png" alt="Google Play" /></a></li>
                                <li><a href="#"><img src="/assets/images/app-store.png" alt="App Store" /></a></li>
                            </ul>
                        </div>
                        {/* Download App Button End */}

                    </div>
                    {/* Download App Wrapper End */}
                </div>
            </div>
        );
    }
    return (

        <>
            {/* Download App Start*/}
            {/* {DownloadApp()} */}
            {/* Download App End */}
            <footer id="footer">
                {/* Footer Start  */}
                <div className="section footer-section">

                    {/* Footer Widget Section Start */}
                    <div className="footer-widget-section">

                        <img className="shape-1 animation-down" src="/assets/images/shape/shape-21.png" alt="Shape" />

                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 order-md-1">

                                    {/* Footer Widget Start */}
                                    <div className="footer-widget">
                                        <div className="widget-logo">
                                            <a href="#"><SiteLogo height={36} /></a>
                                        </div>

                                        <div className="widget-address">
                                            <h4 className="footer-widget-title">{t("footer.aboutUs")}</h4>
                                            <div className="widget-subscribe">

                                            <p>{t("footer.aboutP1", { app: CONFIG_KEYS.ApplicationTitle })}</p>
                                            <p style={{ marginTop: 8 }}>{t("footer.aboutP2")}</p>
                                            </div>
                                        </div>

                                        <ul className="widget-social">
                                            <li><a href="https://www.facebook.com/profile.php?id=61592764001047"><i className="flaticon-facebook"></i></a></li>
                                            {/* <li><a href="#"><i className="flaticon-twitter"></i></a></li>
                                            <li><a href="#"><i className="flaticon-skype"></i></a></li> */}
                                            <li><a href="https://www.instagram.com/myedulinknet/"><i className="flaticon-instagram"></i></a></li>
                                        </ul> 
                                    </div>
                                    {/* Footer Widget End */}

                                </div>
                                <div className="col-lg-8 col-md-6 order-md-2">

                                    {/* Footer Widget Link Start */}
                                    <div className="footer-widget-link">

                                    {/* Footer Widget Start */}
                                    <div className="footer-widget">
                                        <h4 className="footer-widget-title">{t("footer.category")}</h4>

                                        <ul className="widget-link" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", columnGap: 24 }}>
                                            { categories?.map(cat => (
                                                    <li key={cat.token}>
                                                        <a href={pageRouteUrls.SearchByCategory(cat.token, cat.categoryName)}>
                                                            {cat.categoryName}
                                                        </a>
                                                    </li>
                                                ))
                                            }
                                        </ul>

                                    </div>
                                    {/* Footer Widget End */}

                                    {/* Footer Widget Start */}
                                    <div className="footer-widget">
                                        <h4 className="footer-widget-title">{t("footer.helpSupport")}</h4>

                                        <ul className="widget-link">
                                            <li><a href={pageRouteUrls.HelpCenter()}>{t("footer.helpCenter")}</a></li>
                                            <li><a href={pageRouteUrls.HelpArticle("how-the-platform-works")}>{t("footer.gettingStarted")}</a></li>
                                            <li><a href={pageRouteUrls.HelpArticle("billing-overview")}>{t("footer.paymentsBilling")}</a></li>
                                            <li><a href={pageRouteUrls.ContactUs()}>{t("footer.customerSupport")}</a></li>
                                            <li><a href={pageRouteUrls.PrivacyPolicy()}>{t("footer.privacyPolicy")}</a></li>
                                            <li><a href={pageRouteUrls.TermsAndConditions()}>{t("footer.termsConditions")}</a></li>
                                            <li><a href={pageRouteUrls.Pricing()}>{t("footer.pricing")}</a> </li>
                                        </ul>

                                        {/* Support email — direct line for help requests */}
                                        <p className="footer-support-email" style={{ marginTop: 12, fontSize: 14 }}>
                                            {t("footer.emailSupport")}{" "}
                                            <a href="mailto:support@myedulink.net">support@myedulink.net</a>
                                        </p>
                                        <p><i className="flaticon-phone-call"></i> <a href="tel:+12362047735">+1(236) 204-7735</a></p> 
                                    </div>
                                    {/* Footer Widget End */}

                                    </div>
                                    {/* Footer Widget Link End */}

                                </div>
                            </div>
                        </div>

                        <img className="shape-2 animation-left" src="/assets/images/shape/shape-22.png" alt="Shape" />

                    </div>
                    {/* Footer Widget Section End */}

                    {/* Footer Copyright Start */}
                    <div className="footer-copyright">
                        <div className="container">

                            {/* Footer Copyright Start */}
                            <div className="copyright-wrapper">
                                <div className="copyright-link">
                                    <a href={pageRouteUrls.TermsAndConditions()}>{t("footer.termsOfService")}</a>
                                    <a href={pageRouteUrls.PrivacyPolicy()}>{t("footer.privacyPolicy")}</a>
                                    <a href={pageRouteUrls.HelpCenter()}>{t("footer.helpCenter")}</a>
                                    <a href={pageRouteUrls.ContactUs()}>{t("footer.contact")}</a>
                                </div>
                                <div className="copyright-text">
                                    <p>&copy; {(new Date()).getFullYear()} <span style={{textTransform:"unset"}}> {CONFIG_KEYS.ApplicationShortName} </span> {t("footer.madeWithBy")} <span style={{ color: "#e25555" }} aria-label="love">&#10084;</span> by <a href="https://www.mysoftstudio.net/">Mysoft Studio</a></p>
                                </div>
                            </div>
                            {/* Footer Copyright End */}

                        </div>
                    </div>
                    {/* Footer Copyright End */}

                </div>
                {/* Footer End */}

            </footer>
        </>
    )
}